<template>
  <!--<a href="/course" id="courseCardSquare" target="_blank">-->
    <router-link :to="{name:'course', params:{id:id}}" id="courseCardSquare" target="_blank">
    <div class="card raiseOnHover">

      <!--If course has image, display the image. Otherwise display a default image according to its domain.-->
      <div class="courseImg" v-bind:style="{ backgroundImage: 'url(' + image + ')' }"></div>

      <div class="courseInfo">
        <p class="note" v-if="this.provider">{{provider}}</p>
        <p class="note" v-if="this.platform">via {{platform}}</p>
        <h4 v-html="title"></h4>
      </div>
    </div>
    </router-link>
  <!--</a>-->
</template>

<script>
export default {
  name: 'CourseCardSquare',
  props: {
    id: Number,
    image: String,
    provider: String,
    platform: String,
    title: String,
    domain: String
  },

}
</script>



// WEBPACK FOOTER //
// src/view/General/CourseCardSquare.vue